/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

$("label.widget-custom-open").click(function(){
  var customAmount = $("input#custom-amount").val();
  if (customAmount != "") {
    customAmount += " Kč";
  }
  $(".widget-submit-value").text(customAmount);
});
$("input#custom-amount").on("input", function(){
  var customAmount = $("input#custom-amount").val();
  customAmount += " Kč";
  $(".widget-submit-value").text(customAmount);
});
$("label[for='entry-66715760a7be6']").click(function(){
  $(".widget-submit-value").text("2 000 Kč");
});
$("label[for='entry-66715760a7c96']").click(function(){
  $(".widget-submit-value").text("1 000 Kč");
});
$("label[for='entry-66715760a7cc1']").click(function(){
  $(".widget-submit-value").text("600 Kč");
});
$("label[for='entry-66715760a7ce3']").click(function(){
  $(".widget-submit-value").text("200 Kč");
});